<script>
  import { flip } from "svelte/animate";
  import { fly } from "svelte/transition";
  import Sets from "./Sets.svelte";
  import Work from "./Work.svelte";
  import ExpandButton from "./ExpandButton.svelte";
  import SetupWrapper from "./SetupWrapper.svelte";
  import Actions from "./Actions.svelte";
  import BackToQuickstart from "./BackToQuickstart.svelte";
  import Container from "./Container.svelte";
  import RoundName from "./RoundName.svelte";
  import Prepare from "./Prepare.svelte";
  import Cooldown from "./Cooldown.svelte";
  import Name from "./Name.svelte";
  import { id } from "../utils/utils";
  import { getSetupFromURL } from "../utils/parseUrl";
  export let setup;
  export let urlParams;
  let draggable = false;

  let placeholder =
    "e.g.“CHELSEA”\nEMOM for 30 minutes\n5 Pull-Ups\n10 Push-Ups\n15 Air Squats\nhttps://wodwell.com/wod/chelsea";

  let hovering = false;

  let isSetupExapnded = false;

  isSetupExapnded = getSetupFromURL(urlParams, setup);

  function expandSetup() {
    isSetupExapnded = true;
    let rounds = [];
    for (var i = 0; i < setup.sets; i++) {
      let round = {
        id: id(),
        name: "round " + (i + 1),
        work: {
          min: setup.work.min,
          sec: setup.work.sec,
        },
      };
      rounds.push(round);
    }
    setup.expanded.rounds = rounds;
    Object.assign(setup.expanded.prepare, setup.prepare);
    Object.assign(setup.expanded.cooldown, setup.cooldown);
    if (setup.id) {
      setup.id = null;
    }
  }

  function backToQuickstart() {
    isSetupExapnded = false;
    setup.expanded.rounds = [];
    if (setup.id) {
      setup.id = null;
    }
  }

  function removeRound(round) {
    let i = setup.expanded.rounds.indexOf(round);
    setup.expanded.rounds = [
      ...setup.expanded.rounds.slice(0, i),
      ...setup.expanded.rounds.slice(i + 1),
    ];
  }

  const drop = (event, target) => {
    event.dataTransfer.dropEffect = "move";
    const start = parseInt(event.dataTransfer.getData("text/plain"));
    const newTracklist = setup.expanded.rounds;
    if (start < target) {
      newTracklist.splice(target + 1, 0, newTracklist[start]);
      newTracklist.splice(start, 1);
    } else {
      newTracklist.splice(target, 0, newTracklist[start]);
      newTracklist.splice(start + 1, 1);
    }
    setup.expanded.rounds = newTracklist;
    hovering = null;
    draggable = false;
  };

  const dragstart = (event, i) => {
    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.dropEffect = "move";
    const start = i;
    event.dataTransfer.setData("text/plain", start);
  };

  function addRound() {
    let round = {
      id: id(),
      name: "",
      work: {
        min: setup.work.min,
        sec: setup.work.sec,
      },
    };
    setup.expanded.rounds = [...setup.expanded.rounds, round];
  }
</script>

{#if !isSetupExapnded}
  <SetupWrapper>
    <Sets bind:sets={setup.sets} />
    <Work bind:work={setup.work} />
    <ExpandButton on:expandSetup={expandSetup} />
    <Actions {setup} on:startWorkout />
  </SetupWrapper>
{:else}
  <SetupWrapper>
    <BackToQuickstart on:backToQuickstart={backToQuickstart} />
    <Name bind:name={setup.expanded.name} />
    <Container>
      <h4 class="text-base text-center pt-4">description</h4>
      <div class="w-full flex justify-center items-center">
        <textarea
          bind:value={setup.expanded.description}
          class="focus:ring-4 ring-gray-500 focus:outline-none ring-opacity-30 font-semibold p-2 bg-gray-600 border-0 rounded-xl w-full h-40"
          {placeholder}
          rows="5"
        />
      </div>
    </Container>
    <Prepare bind:prepare={setup.expanded.prepare} />
    {#each setup.expanded.rounds as round, index (round.id)}
      <div
        {draggable}
        on:dragstart={(event) => dragstart(event, index)}
        on:drop|preventDefault={(event) => drop(event, index)}
        ondragover="return false"
        on:dragenter={() => (hovering = index)}
        class:is-active={hovering === index}
        animate:flip={{ duration: 500 }}
        transition:fly|local={{ x: 20 }}
        class="relative rounded-3xl px-4 pb-3 pt-2 bg-gray-900 backdrop-filter backdrop-blur-md bg-opacity-50 shadow-white sm:self-start "
      >
        <button
          class="btn absolute left-0 top-0"
          aria-label="Drag and drop"
          on:mousedown={() => (draggable = true)}
          on:mouseup={() => (draggable = false)}
          on:touchstart={() => (draggable = true)}
          on:touchend={() => (draggable = false)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M4 6h16M4 10h16M4 14h16M4 18h16"
            />
          </svg>
        </button>
        <button
          on:click={() => removeRound(round)}
          class="btn absolute right-0 top-0"
          aria-label="remove round"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            />
          </svg>
        </button>

        <RoundName bind:round />
        <Work bind:work={round.work} />
      </div>
    {/each}
    <div class="w-full flex justify-center items-center">
      <button
        title="Expand"
        aria-label="Add new round"
        on:click={addRound}
        class="active:text-gray-400 cursor-pointer select-none focus:outline-none transform hover:scale-125 focus:scale-125 transition duration-200 ease-in-out rounded-full focus:bg-gray-300 focus:bg-opacity-30"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-8 w-8"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
    </div>
    <Cooldown bind:cooldown={setup.expanded.cooldown} />
    <Actions {setup} on:startWorkout on:expandSetup={expandSetup} />
  </SetupWrapper>
{/if}

<style>
  .is-active {
    background-color: #3273dc;
    color: #fff;
  }
</style>
